import sanitizeHtml from "sanitize-html";

/** Same allowlist on server and client; links remain dedicated recommendation actions. */
export const recommendationHtml = (description?: string | null): string =>
  sanitizeHtml(description ?? "", {
    allowedTags: [
      "p",
      "div",
      "br",
      "strong",
      "b",
      "em",
      "i",
      "u",
      "s",
      "ul",
      "ol",
      "li",
      "blockquote",
    ],
    allowedAttributes: {},
  });
